"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var MarkerLayer_1 = require("./MarkerLayer");
var Marker = function (props) {
    var markerLayer = react_1.useContext(MarkerLayer_1.MarkerLayerContext);
    var _a = props.coords, lng = _a.lng, lat = _a.lat;
    var coords = window.SMap.Coords.fromWGS84(lng, lat);
    var sMarker = new window.SMap.Marker(coords, false);
    markerLayer === null || markerLayer === void 0 ? void 0 : markerLayer.addMarker(sMarker);
    react_1.useEffect(function () {
        return function () {
            markerLayer.removeMarker(sMarker, true);
        };
    });
    return null;
};
exports.default = Marker;
//# sourceMappingURL=Marker.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-mapycz/lib/Marker.js
// module id = 189
// module chunks = 0